import {
  Component, Renderer2, ElementRef,
  OnInit, OnDestroy, Input, ViewChild,
  Output, EventEmitter,
} from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Component({
  moduleId: module.id,
  selector: 'app-tooltip',
  templateUrl: 'tooltip.component.html',
  styleUrls: ['tooltip.component.scss'],
})
export class AppTooltipComponent implements OnInit, OnDestroy {
  documentClickListener: any;

  @Input() innerHtml: any;
  @Input() iconClass: string;
  @Input() tooltipClass: string;
  @Input() placement: string = 'top';
  @Input() triggers: string = 'hover';
  @Input() toBody: boolean = false;
  @Input() contentAlign: string = 'center';
  @Input() small: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isVersion2: boolean = false;
  @Input() isOnlyText: boolean = false; // if it's only text tooltip

  @Output() onShown: EventEmitter<any> = new EventEmitter<any>();
  @Output() onHidden: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('tooltip', {static: false}) tooltip: TooltipDirective | void;

  constructor(
    private renderer: Renderer2,
    private ref: ElementRef,
  ) {}

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get contentAlignClass() {
    return `align-${this.contentAlign}`;
  }

  get containerClass() {
    let classesStr = this.isVersion2 ? 'version-2' : '';
    if (this.tooltipClass) {
      classesStr = `${classesStr} ${this.tooltipClass}`;
    }
    return classesStr;
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    if (this.triggers && this.triggers.indexOf('click') >= 0) {
      this.documentClickListener = this.renderer.listen(document, 'click', (event: any) => {
        // if it's not this element and children
        const iconClass = this.iconClass ? `app-tooltip-inner ${this.iconClass}` : 'app-tooltip-inner';
        if (!event.target.classList.contains(iconClass)
          && !this.ref.nativeElement.contains(event.target)) {
          if (this.tooltip instanceof TooltipDirective) {
            this.tooltip.hide();
          }
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }
}
